import { render, staticRenderFns } from "./CustomerCoupons.vue?vue&type=template&id=13ca6dfe&scoped=true"
import script from "./CustomerCoupons.vue?vue&type=script&lang=js"
export * from "./CustomerCoupons.vue?vue&type=script&lang=js"
import style0 from "./CustomerCoupons.vue?vue&type=style&index=0&id=13ca6dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca6dfe",
  null
  
)

export default component.exports